import { Image, ImageProps } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet } from 'react-native';

export type RapidRescueCardProps = Omit<ImageProps, 'children' | 'source'> & {
  pickUpHref: string;
};

export function RapidRescueCard({ pickUpHref, ...imageProps }: RapidRescueCardProps) {
  return (
    <Link href={pickUpHref} asChild>
      <Pressable>
        <Image
          alt="Avoid The Wait. Order Online. Order Now"
          source={require('./rapid-rescue-banner.webp')}
          placeholder={{ thumbhash: 'sigKHgT6aNiGZ6doh3OYflaoNKBEICk' }}
          {...imageProps}
          style={[styles.rapidRescue, imageProps.style]}
        />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  rapidRescue: {
    aspectRatio: 1137 / 1270,
  },
});
